// extracted by mini-css-extract-plugin
module.exports = {"canClick":"Breadcrumb_canClick__3cwNb","icon":"Breadcrumb_icon__B7s8o","color":"Breadcrumb_color__1NWTT"};